import * as Yup from 'yup';

/*
  What a message is about, as its sender classifies it. Every message sent from SCE Reports or the
  Customers pages carries one.

  The id is what msg.History.Category stores and the name is the button's label - not always the
  same words. The hint is the button's tooltip: what a message in that Category is for. The server
  accepts exactly these ids (MsgHistoryCategories), so change both together.
*/
export const MESSAGE_CATEGORIES = [
  { id: 'Opportunity', name: 'Opportunity', hint: 'Customers know their opportunities' },
  { id: 'NetPsn', name: 'Net Position', hint: 'Customers know their net position' },
  { id: 'General', name: 'Not Forgotten', hint: 'Customers never feel forgotten' },
  { id: 'WeCare', name: 'We Care', hint: 'Customers know we care' },
];

// SCE Reports' compose windows start on this one - an SCE Report tells a customer their net position.
// The sender can still pick another. The Customers pages start on none.
export const SCE_REPORTS_DEFAULT_CATEGORY = 'NetPsn';

/* A stored Category as its label - anything unrecognised (an empty Category) as it is. */
export const messageCategoryLabel = (id?: string | null) =>
  MESSAGE_CATEGORIES.find((category) => category.id === id)?.name ?? id ?? '';

// No button is picked when a window opens, so this is what makes the sender choose one.
export const messageCategorySchema = Yup.string().nullable().required('Select a Category');
